import { render, staticRenderFns } from "./MessageTimelineItem.vue?vue&type=template&id=5a0a66aa"
import script from "./MessageTimelineItem.vue?vue&type=script&lang=js"
export * from "./MessageTimelineItem.vue?vue&type=script&lang=js"
import style0 from "./MessageTimelineItem.vue?vue&type=style&index=0&id=5a0a66aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports